import apiClient from "../api/apiClient";

const API = "/Products";
const Category_API = "/Categories/GetAll";
const Brand_API = "/Brands/GetActiveAll";
const Material_API = "/Material/GetActiveAll";
const STONE_TYPE_API="/StoneTypes/GetActiveAll";
const OCCASION_API="/OccasionTypes/GetActiveAll";
export const getProducts = async () => {
  const res = await apiClient.get(API);
  return res.data;
};

export const getCategories = async () => {
  const res = await apiClient.get(Category_API);
  return res.data;
};
export const getBrands = async () => {
  const res = await apiClient.get(Brand_API);
  return res.data;
};
export const getMaterials = async () => {
  const res = await apiClient.get(Material_API);
  return res.data;
};
export const getStoneType = async () => {
  const res = await apiClient.get(STONE_TYPE_API);
  return res.data;
};
export const getOccasionType = async () => {
  const res = await apiClient.get(OCCASION_API);
  return res.data;
};

export async function createProduct(
  data: FormData
) {

  const res = await apiClient.post(
    API,
    data,
    {
      headers: {
        "Content-Type":
          "multipart/form-data"
      }
    }
  );

  return res.data;
}

export const updateProduct = async (
  id: number,
  data: any
) => {
  const res = await apiClient.put(
    `${API}/${id}`,
    data
  );

  return res.data;
};

export const deleteProduct = async (
  id: number
) => {
  return apiClient.delete(`${API}/${id}`);
};
